<header id="mainHeader" class="container">
  <nav class="home-navbar navbar navbar-expand-lg">
    <a href="#" class="area-logo navbar-brand" [routerLink]="['/']">
      <figure class="mb-0">
        <picture>
          <img
            [src]="logoUrl"
            alt="Logo Tele Prêmios da Sorte"
            title="Tele Prêmios da Sorte" />
        </picture>
      </figure>
    </a>

    <div class="area-menu">
      <div class="navbar-toggler p-0">
        <app-menu-mobile
          [userInfo]="{ isLoggedIn, userFirstName }"
          [principalMenu]="principalMenu"
          [userMenu]="userMenu"
          (logout)="logout()" />
      </div>

      <div class="collapse navbar-collapse" id="navbarNav">
        <app-menu-desktop
          class="collapse navbar-collapse"
          id="navbarNav"
          [menu]="principalMenu" />
      </div>
    </div>

    <div class="area-usuario d-flex align-items-center">
      <button
        *ngIf="evento"
        id="header-carrinho"
        class="btn btn-link text-primary position-relative"
        type="button"
        [tooltip]="showCartTooltip"
        containerClass="custom-tooltip"
        placement="right"
        container="body"
        [routerLink]="['/carrinho.html']"
        aria-label="Botão exibe tooltip com informações sobre a compra de títulos">
        <span class="d-none d-lg-block">
          <span
            *ngIf="!emptyCart"
            class="position-absolute top-0 end-0 badge rounded-pill bg-secondary">
            {{ evento.quantity }}
          </span>

          <span class="bi bi-cart3" [style.font-size.px]="46"></span>
        </span>

        <span class="d-md-block d-lg-none">
          <span class="position-absolute top-0 badge badge-xs rounded-pill">
            {{ evento.quantity || '' }}
          </span>

          <img src="/assets/img/cart-icon.svg" alt="Ícone de carrinho" />
        </span>
      </button>

      <div class="d-none d-lg-block">
        <div class="d-flex position-relative">
          <button
            id="header-perfil"
            class="nav-link perfil text-primary"
            type="button"
            data-bs-toggle="dropdown"
            data-bs-target="#opcoesUsuario"
            aria-controls="opcoesUsuario"
            aria-expanded="false"
            aria-label="Toggle navigation">
            <span class="bi bi-person-fill"></span>
          </button>

          <ul class="dropdown-menu" id="opcoesUsuario">
            <ng-container *ngFor="let item of userMenu">
              <li>
                <a
                  class="dropdown-item text-primary"
                  [routerLink]="[item.url]"
                  >{{ item.title }}</a
                >
              </li>
            </ng-container>

            <ng-container *ngFor="let item of loginMenu">
              <li *ngIf="!isLoggedIn">
                <a
                  class="dropdown-item text-primary"
                  [routerLink]="[item.url]"
                  >{{ item.title }}</a
                >
              </li>
            </ng-container>

            <li *ngIf="isLoggedIn">
              <button class="dropdown-item text-primary" (click)="logout()">
                sair
              </button>
            </li>
          </ul>

          <span class="text-primary" [style.font-size.px]="12">
            <ng-container *ngIf="isLoggedIn; else genericAccessTemplate">
              olá {{ userFirstName }}!
            </ng-container>
          </span>
        </div>
      </div>
    </div>
  </nav>
</header>

<ng-template #genericAccessTemplate>Meu acesso</ng-template>

<ng-template #tooltipCartTemplate>
  <ng-container *ngIf="evento">
    <p [style.font-size.px]="14"><strong>Compra pendente</strong></p>
    <p [style.font-size.px]="12">
      <strong>
        {{ evento.quantity }} título(s), Campanha
        {{ evento.name }}
      </strong>
    </p>
    <p>
      <span [style.font-size.px]="14">
        <strong>
          {{ totalValue | currency }}
        </strong>
      </span>
    </p>
  </ng-container>
</ng-template>
